import React from 'react';
import { FormContainer, FormDescription, FormHeader } from './PublicStyles';

export default function NotVerified() {
  return (
    <FormContainer>
      <FormHeader>This link is expired or doesn't exist</FormHeader>
      <FormDescription>
        It seems like this link is expired or doesn't exist. No worries, our
        customer support team is here to help! Please contact us for assistance.
      </FormDescription>
    </FormContainer>
  );
}
